<template>
    <div>
        <!--encabezado-->
        <div class="vx-row">
            <!--CARD IZQUIERDO-->
            <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-5/6 xl:w-5/6 mb-6">
                <!--Encabezado-->
                <p class="color1 text-2xl text-center">Evaluación de {{datos.libro}}</p>
                <vs-divider></vs-divider>
                <p class="mt-3"><b class="color1">Disponible: </b> {{ evaluacion.fecha_inicio }} - {{ evaluacion.fecha_fin }}</p>
                <div class="flex mt-2">
                    <span class="mr-3"><b class="color1">Puntos: </b> {{ setEvaluacion.puntaje }}</span>
                    <span><b class="color1">Límite de tiempo: </b> {{ setEvaluacion.tiempo }} minutos</span>
                </div>
                <vs-divider class="mt-3"></vs-divider>
                <!--Instrucciones-->
                    <p class="color1 text-2xl text-left">Instrucciones</p>
                    <p class="mt-3 color2 tamanio1">
                        Esta evaluación no solo es una oportunidad para medir tu progreso, sino también una herramienta valiosa para tu crecimiento académico. Cada pregunta está diseñada para desafiar tus habilidades y fomentar la comprensión profunda de los temas.
                    </p>
                    <p class="mt-2 color2 tamanio1">
                        Cuando estes listo, presiona el botón <b>"Realizar la Evaluación". </b>
                    </p>
                    <p class="mt-2 color2 tamanio1">
                        * Dispones de <b>{{ setEvaluacion.tiempo }} minutos</b> para completar la evaluación.
                    </p>
                    <p class="mt-2 color2 tamanio1">
                        * Tienes <b>{{ setEvaluacion.intentos }} intentos</b>  para completar la evaluación.
                    </p>                    
                    <p class="mt-1 color2 tamanio1">
                        * El puntaje de esta evaluación es <b>{{ setEvaluacion.puntaje }} puntos.</b>
                    </p>
                    <p class="mt-5 color2 tamanio1">
                        <b>Nota:</b> Se activará un cronómetro para indicarte el tiempo que 
                        lleva realizando el cuestionario. Este cronómetro no se detendrá a pesar de que salga de la página
                        del cuestionario y navegue por la plataforma. Por esta razón, solo cuando esté seguro en realizar la evaluación, inicie. 
                    </p>
                    <p class="mt-5 color2 tamanio1">
                        <b>Comentario de su profesor/a:</b> <br/> {{ setEvaluacion.indicaciones }}
                    </p>
                    <!--FIN INSTRUCCIONES-->
                    <!--TABLA DE INTENTOS-->
                    <p class="color1 text-2xl text-left" style="margin-top: 30px;">Historial de intentos</p>
                    <table class="table-auto w-full" v-if="setEvaluacionRealizadas.length > 0">
                        <thead>
                            <tr>
                                <th class="px-4 py-2">Intento</th>
                                <th class="px-4 py-2">Fecha finaliza</th>
                                <th class="px-4 py-2">Puntaje</th>
                                <th class="px-4 py-2">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,key) in setEvaluacionRealizadas" :key="key">
                                <td class="border px-4 py-2">{{ key+1 }}</td>
                                <td class="border px-4 py-2">{{ item.fecha_finaliza }}</td>
                                <td class="border px-4 py-2">{{ item.calificacion }}</td>
                                <td class="border px-4 py-2">
                                    <span v-if="item.estado == 0">En curso</span>
                                    <div v-if="item.estado == 1">
                                        <span class="mr-3">Finalizado</span>
                                        <vs-button  type="border" @click="mostrarEvaluacionIntento(item,key+1)" class="p-2" color="#4CBAD2" size="small"><i class="fa-solid fa-file-signature"></i> Ver Evaluación</vs-button>
                                    </div>
                                    <span v-if="item.estado == 2">Anulado</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else>
                        <p class="color2 text-center">No hay intentos realizados</p>
                    </div>
            </div>
            <!--CARD DERECHO-->
            <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/6 xl:w-1/6 mb-6">
                <div class="flex justify-center mt-3">
                    <vs-button color="primary" class="p-3" v-if="intentosRealizados.length < setEvaluacion.intentos" @click="realizarEvaluacion();"><i class="fa-solid fa-pen-to-square"></i> Realizar Evaluación</vs-button>
                </div>
                <vs-divider></vs-divider>
                <p class="color1 text-2xl text-center">Detalles</p>
                <vs-divider></vs-divider>
                <div class="vx-row" v-if="ultimoIntento">
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">
                            <b>Hora inicio:</b>
                        </p>
                    </div>
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">{{ ultimoIntento.fecha_comienza }}</p>
                    </div>
                </div>
                <vs-divider v-if="ultimoIntento"></vs-divider>
                <div class="vx-row" v-if="ultimoIntento">
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">
                            <b>Hora fin:</b>
                        </p>
                    </div>
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">{{ ultimoIntento.fecha_finaliza }}</p>
                    </div>
                </div>
                <vs-divider v-if="ultimoIntento"></vs-divider>
                <div class="vx-row" v-if="ultimoIntento">
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/">
                        <p class="mt-1 color2 tamanio1">
                            <b>Puntaje actual:</b>
                        </p>
                    </div>
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/">
                        <p class="mt-1 color2 tamanio1">{{ ultimoIntento.calificacion }} de {{ setEvaluacion.puntaje }}</p>
                    </div>
                </div>
                <vs-divider v-if="ultimoIntento"></vs-divider>
                <div class="vx-row" v-if="ultimoIntento">
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">
                            <b>Puntaje Final:</b>
                        </p>
                    </div>
                    <div class="vx-col w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
                        <p class="mt-1 color2 tamanio1">{{ datosCalificacion.calificacion }} de {{ setEvaluacion.puntaje }}</p>
                    </div>
                </div>
                <vs-divider v-if="ultimoIntento"></vs-divider>
                <!--===RUBRICA===-->
                <div v-if="datosCalificacion.rubrica_calificacion > 0">
                    <p class="text-success text-center mt-2"><i class="fa-solid fa-circle-check"></i> Rúbrica realizada</p>
                </div>
                <div v-else>                    
                    <h4 class="text-danger text-center"><i class="fa-solid fa-triangle-exclamation"></i> Rúbrica No realizada</h4>
                </div>
            </div>
        </div>
        <!--MODALES-->
        <!--modal para ver intento-->
        <vs-popup classContent="popup-example" fullscreen title="Mostrar evaluación" :active.sync="popupMostrarEvaluacion">
            <div v-if="popupMostrarEvaluacion">
                <div v-if="arrayPreguntas.length > 0">
                    <EvaluacionRevisarVue :setEvaluacion="setEvaluacion" :ObjectEvaluacion="{ estudiante:usuario.nombre+' '+usuario.apellido }" :arrayPreguntas="arrayPreguntas"  :intentoSelected="intentoSelected"/>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
  import {
    mapState
} from "vuex";
import moment from 'moment';
moment.locale('es')
import GeneralMixin from "@/mixins/GeneralMixin.js";
const EvaluacionRevisarVue = () => import("../../docentes/evaluaciones/EvaluacionesRevision/EvaluacionRevisar.vue");
export default {
    mixins: [GeneralMixin],
    components: {
        EvaluacionRevisarVue,
    },
    data() {
        return{
            usuario:[],
            ultimoIntento:'',
            sumarCalificaciones:0,
            evaluacion:{
                fecha_inicio:null,
                fecha_fin:null,
            },
            idlibro:0,
            intentosRealizados:[],
            popupRubrica:false,
            arrayPreguntasRubrica:[],
            datosCalificacion:{
                calificacion:0,
                rubrica_calificacion:0,
            },
            popupMostrarEvaluacion:false,
            intentoSelected:'',
            arrayPreguntas:[],
        }  
    },
    props:{
        datos:{
            type:Object,
            default:()=>({})
        },
        setEvaluacionRealizadas:{
            type:Array,
            default:() => []
        }
    },
    watch:{
        setEvaluacionRealizadas(results){
            let me = this
            if(results.length > 0){
                me.start()
                me.setEvaluacionRealizadas = results
            }
        },
        setCalificacion(results){
            let me = this
            if(results){
                me.startCalificacion()
            }
        }
    },
    computed: {
        ...mapState(['setEvaluacion','setCalificacion'])
    },
    created(){
        let me = this
        this.usuario    = JSON.parse(localStorage.getItem('usuario'))[0]
    },
    mounted(){
        let me = this
        me.idlibro = localStorage.getItem('idlibro')
        setTimeout(() => {
            this.start()
            me.startCalificacion()
        }, 1000);
    },
    methods:{
        mostrarEvaluacionIntento(item,key){
            let me = this
            me.intentoSelected = item
            me.intentoSelected.intento = "Intento " +key
            if(me.intentoSelected == '' || me.intentoSelected == null || me.intentoSelected == undefined) return me.f_notificaciones("Seleccione un intento", "warning");
            me.arrayPreguntas = []
            let formData = new FormData();
            formData.append('id_evaluacion_estudiante',this.intentoSelected.id_evaluacion_estudiante);
            formData.append('traerEvaluacionIntento','1')
            me.$vs.loading()
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                me.arrayPreguntas = res.data
                //excluir las preguntas abiertas con id 7
                me.arrayPreguntas = me.arrayPreguntas.filter((i) => i.id_tipo != me.idPreguntaAbierta)
                //juntar al ultimo las preguntas abiertas 
                me.arrayPreguntas = [...me.arrayPreguntas,...res.data.filter((i) => i.id_tipo == me.idPreguntaAbierta)]
                //si es de id_tipo == 5 en la propiedad respuestas se guarda un json porque son preguntas de tipo columna
                me.arrayPreguntas.forEach((i,index) => {
                    if(i.id_tipo == 5 || i.id_tipo == 8){
                        if(i.respuestas.length > 0){
                            //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse
                            if(i.respuestas[0].respuesta != null && i.respuestas[0].respuesta != ''){
                                i.respuestas[0].respuesta = JSON.parse(i.respuestas[0].respuesta)
                                //si es pregunta de tipo 8 que es pregunta de seleccion multiple
                                if(i.id_tipo == 8){
                                    i.respuestas[0].respuesta.forEach((j) => {
                                        if(j.seleccionar == "true"){
                                            j.seleccionar = true
                                        }else if(j.seleccionar == "false"){
                                            j.seleccionar = false
                                        }
                                    })
                                }
                            }else{
                                //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse y coloco array vacio
                                i.respuestas[0].respuesta = []
                            }
                        }
                    }
                })
                me.popupMostrarEvaluacion = true
            })
            .catch(err => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al traer la evaluación "+err, "danger");
            })
        },
        startCalificacion(){
            let me = this
            if(me.setCalificacion.length > 0){
                let arrayCalificacionTotal                  = me.setCalificacion
                me.datosCalificacion.calificacion           = arrayCalificacionTotal[0].calificacion
                me.datosCalificacion.rubrica_calificacion   = arrayCalificacionTotal[0].rubrica_calificacion
                
            }else{
                me.datosCalificacion.calificacion           = 0
                me.datosCalificacion.rubrica_calificacion   = 0
            }
        },
        start(){
            let me = this
            me.ultimoIntento                = ''
            me.sumarCalificaciones          = 0
            me.evaluacion.fecha_inicio      = moment(me.setEvaluacion.fecha_inicio).format('MMMM DD YYYY h:mm a')
            me.evaluacion.fecha_fin         = moment(me.setEvaluacion.fecha_fin).format('MMMM DD YYYY h:mm a')
            //sumar cuantos intentos con estado 1 tengo
            me.intentosRealizados           = me.setEvaluacionRealizadas.filter(e => e.estado == 1)
            //si los intentos realizados es mayor a 0 
            if(me.intentosRealizados.length > 0){
                //obtener el ultimo intento si el array son 2 o mas
                if(me.setEvaluacionRealizadas.length > 1){
                    me.ultimoIntento            = me.setEvaluacionRealizadas[me.setEvaluacionRealizadas.length-1]
                }else{
                    me.ultimoIntento            = me.setEvaluacionRealizadas[0]
                }
                //sumar calificaciones y dividir por la cantidad de intentos
                me.sumarCalificaciones          = me.intentosRealizados.reduce((a,b) => a + b.calificacion, 0) / me.intentosRealizados.length
            }
        },
        realizarEvaluacion(){
            let me = this
            //post
            let formData = new FormData();
            formData.append('generateEvaluacion',1);
            formData.append('idEvaluacion',me.setEvaluacion.id);
            formData.append('idEstudiante',me.usuario.idusuario);
            me.$vs.loading()
            this.$http.post(this.$server_url+'evaluacionEstudiante', formData)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    me.f_notificaciones(res.data.message, "danger");
                    return
                }
                me.$emit('changehandle',res.data)
            })
            .catch(err => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al realizar la evaluación", "danger");
            })
        },
    }
}
</script>
<style lang="css" scoped>
.color1{
    color:#2F68AD;
}
.color2{
    color:#123156;
    font-weight: 500;
}
.tamanio1{
    font-size: 11px;
}

/*border al tr de la tabla*/
table {
    border-collapse: collapse;
    width: 100%;
    margin-top: 20px;
    font-size: 10px;
}
tr{
    border-bottom: 1px solid #ddd;
    font-size: 12px;
}
</style>
